import React, { useState } from 'react';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as classes from './UserSubscriptionsTableRowMenu.module.css';

import * as CoreActions from '../../actions/coreActions';
import * as SubscriptionActions from '../../actions/subscriptionActions';

const ContactSubscriptionsTableRowMenu = ({
    setProgressBarLoading,
    fetchSubscriptions,
    openEditModal,
    unsubscribe,
    setSubscription,
    isLoading,
    subscription
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    async function handleUnsubscribe() {

        setProgressBarLoading(true);

        handleClose();

        await unsubscribe(subscription.id, 'contacts');

        setProgressBarLoading(false);
    }

    function handleManageSubscription() {
        setSubscription(subscription);
        openEditModal();
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                disabled={isLoading}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleUnsubscribe}>
                    <img
                        alt="Unsubscribe Icon"
                        className={classes.contextIcon}
                        src="/assets/images/unsubscribeIcon.svg"
                    />
                    Unsubscribe
                </MenuItem>
                <MenuItem onClick={handleManageSubscription}>
                    <img
                        alt="Update Icon"
                        className={classes.contextIcon}
                        src="/assets/images/subscriptionsIconColor.svg"
                    />
                    Update Subscription
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        isLoading: state.core.progressBarLoading
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...SubscriptionActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactSubscriptionsTableRowMenu);
